<template>
  <v-dialog v-model="printExportDialog" class="the-app-dialogs" persistent max-width="1100px">
    <v-card>
      <v-layout row class="no-select global-not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon v-if="clickedButton === 'export'" light x-large class="rgba(0,0,0,0.3)--text pb-1"
              >fa-file-excel</v-icon
            >&nbsp;
            <v-icon v-if="clickedButton === 'print'" light x-large class="rgba(0,0,0,0.3)--text pb-1">print</v-icon>
            <span v-if="clickedButton === 'export'" class="px-3">{{ $t('Export Table') }}</span>
            <span v-if="clickedButton === 'print'" class="px-3">{{ $t('Print Table') }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3" id="globalPrintArea">
        <invoice-header class="global-only-for-print" />

        <table class="global-section-title-table global-only-for-print">
          <tr>
            <th class="global-section-title-content">
              <span v-html="sectionTitle.title" />
            </th>
          </tr>
        </table>

        <v-layout row wrap class="global-invoice-content">
          <table class="global-printed-table" id="exported-table" cellspacing="0">
            <thead>
              <tr v-if="showHeaderSpace" class="global-only-for-print">
                <td>
                  <div class="global-header-space">&nbsp;</div>
                </td>
              </tr>
              <tr>
                <th v-for="(header, index) in tableHeader" :key="index" class="pa-2 view-table-header">
                  {{ header.text }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(body, index) in tableBody" :key="index">
                <td class="view-table-row" v-for="(header, i) in tableHeader" :key="i">
                  {{ body[header.value] | currency }}
                </td>
              </tr>
              <tr v-if="tableBody.footer">
                <td class="view-table-row" :colspan="tableHeader.length - 2">
                  <strong>Total</strong>
                </td>
                <td class="view-table-row">
                  <strong>{{ tableBody.footer.total | currency }}</strong>
                </td>
                <td class="view-table-row"></td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="global-only-for-print">
                <td>
                  <div class="global-footer-space">&nbsp;</div>
                </td>
              </tr>
            </tfoot>
          </table>
          <v-footer style="border-top: 1px solid lightgrey" class="print-export-dialog-footer global-not-printable">
            <v-spacer></v-spacer>
            <v-btn outline color="primary" @click="$emit('hidemodal')">
              {{ $t('Close') }}
            </v-btn>

            <v-btn v-if="clickedButton === 'print'" color="primary" @click="printMe()">
              <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">print</v-icon>
              {{ $t('Print') }}
            </v-btn>

            <v-btn v-if="clickedButton === 'export'" color="primary" @click="exportTable()">
              <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">fa-file-excel</v-icon>
              {{ $t('Export') }}
            </v-btn>
          </v-footer>
        </v-layout>

        <invoice-footer
          :showSignatureSection="false"
          :accountantName="''"
          :payerRecipientName="''"
          :payerOrRecipient="''"
          class="global-only-for-print"
        />
      </v-card-title>
    </v-card>
  </v-dialog>
</template>

<script>
import invoiceHeader from '@/views/_partials/invoiceHeader.vue'
import invoiceFooter from '@/views/_partials/invoiceFooter.vue'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'

export default {
  props: {
    printExportDialog: { type: Boolean, required: true },
    tableHeader: { type: Array, required: true },
    tableBody: { type: Array, required: true },
    clickedButton: { type: String, required: true }
  },

  computed: {
    ...mapGetters({
      sectionTitle: 'dashboard/getAppBarTitle'
    })
  },

  components: {
    invoiceHeader,
    invoiceFooter
  },

  data() {
    return {
      showHeaderSpace: true
    }
  },

  methods: {
    exportTable() {
      this.showHeaderSpace = false
      setTimeout(() => {
        var tbl = document.getElementById('exported-table')
        var ws = XLSX.utils.table_to_sheet(tbl)

        // this is to export json to excel
        // var ws = XLSX.utils.json_to_sheet(this.resultData.data)
        // var wscols = [{ width: 'auto' }, { width: 'auto' }] // this line and the line below is to
        // set the width for exported column
        // ws['!cols'] = wscols

        var wb = XLSX.utils.book_new()
        var sheetName = this.sectionTitle.title
        if (this.sectionTitle.title.includes(':')) {
          sheetName = this.sectionTitle.title.substring(0, this.sectionTitle.title.indexOf(':'))
        }
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1')
        XLSX.writeFile(wb, `${sheetName}.xlsx`)
        this.showHeaderSpace = true
      }, 500)
    },

    printMe() {
      let onlyForPrint = document.querySelectorAll('.global-only-for-print')
      let notPrintable = document.querySelectorAll('.global-not-printable')
      let invoiceContent = document.querySelector('.global-invoice-content')
      let theDialogContent = document.querySelector('.view-dialog-content')
      theDialogContent.classList.remove('grey')
      invoiceContent.style.marginTop = '90px'
      notPrintable.forEach(element => {
        element.style.display = 'none'
      })
      onlyForPrint.forEach(element => {
        element.style.display = 'block'
      })
      document.querySelector('.global-printed-table').style.marginTop = '-120px'

      this.$htmlToPaper('globalPrintArea', () => {
        theDialogContent.classList.add('grey')
        invoiceContent.style.marginTop = '0px'
        onlyForPrint.forEach(element => {
          element.style.display = 'none'
        })
        notPrintable.forEach(element => {
          element.style.display = 'flex'
        })
        document.querySelector('.global-printed-table').style.marginTop = '0px'
      })
    }
  }
}
</script>

<style scoped>
.global-only-for-print {
  display: none;
}
</style>
